import React, { useState, useEffect } from 'react';
import { MdStore } from "react-icons/md";
import { FaSquare, FaPiggyBank, FaUserClock, FaCoins } from "react-icons/fa";
import {  RiSwordFill  } from "react-icons/ri";
import { IoPersonAdd } from "react-icons/io5";
import './Reliability.css'


import { AiFillSecurityScan, AiFillSafetyCertificate  } from "react-icons/ai";
import { BsShieldFillExclamation, BsTransparency } from "react-icons/bs";
import { GiSwordsEmblem, GiPayMoney, GiCash } from "react-icons/gi";
import { SiCyberdefenders } from "react-icons/si";
import { LuCalendarClock } from "react-icons/lu";
import { FaMoneyBillWave } from "react-icons/fa";

import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { MdOutlineCenterFocusWeak } from "react-icons/md";
import { PiStrategyBold, PiIdentificationCardFill } from "react-icons/pi";
import { FaUniversalAccess } from "react-icons/fa6";
import { ImConfused2 } from "react-icons/im";
import { HiMiniUserGroup } from "react-icons/hi2";
import { GrCompliance } from "react-icons/gr";






const Reliability = () => {
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [isDashModalOpen, setIsDashModalOpen] = useState(false);


    const goals = [
        {
            goal: 'Reliability and safety guidance',
            PreGoal:'Goal RS1:',
            description: 'Evaluate the operational factors and ranges within which AI systems are expected to perform reliably and safely, remediates issues, and provide related information to customers.',
            appliesTo: 'All AI systems.',
            requirements: [
                {
                    id: 'RS1.1',
                    text: 'Document how:',
                    subRequirements: [
                        "reliable and safe behaviour is defined for this system and,",
                        "what acceptable error rates are for overall system performance in the context of intended uses.",
                    ],
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
                {
                    id: 'RS1.2',
                    text: 'Evaluate training and test data sets to ensure that they include representation of the intended uses, operational factors, and an appropriate range of settings for each factor. Document the evaluation.',
                    tags: null
                },
                {
                    id: 'RS1.3',
                    text: 'Determine and document the operational factors, including quality of system input, use, and operational context that are critical to manage for reliable and safe use of the system in its deployed context.',
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
                {
                    id: 'RS1.4',
                    text: 'Define and document acceptable ranges for each operational factor important to support reliable and safe system use. Define and document an acceptable error rate for the system when operating within these ranges.',
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
                {
                    id: 'RS1.5',
                    text: 'Define intended uses, if any, where additional operational factors, more narrow or different acceptable ranges, or lower acceptable error rates (including false positive and false negative error rates), are advised to ensure reliability and safety. Document your conclusions.',
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
                {
                    id: 'RS1.6',
                    text: 'Define and document an evaluation plan based on requirements RS1.1, RS1.3, RS1.4, and RS1.5, to include the environment in which the system will be evaluated.',
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
                {
                    id: 'RS1.7',
                    text: 'Evaluate the system according to the evaluation plan defined in requirement RS1.6 to ensure reliable and safe system behaviour. Document the pre-release results of the evaluation. Determine and document how often ongoing evaluation should be conducted to continue supporting this goal.',
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
                {
                    id: 'RS1.8',
                    text: 'In the event of failure cases within operational factors and defined ranges, work to resolve the issues. If the Responsible Release Criteria established in requirements RS1.1, RS1.3, RS1.4, and RS1.5 cannot be met, a reassessment of intended uses and updated documentation is required.',
                    tags:['Ongoing Evaluation Checkpoint.']
                },
                {
                    id: 'RS1.9',
                    text: 'Provide documentation to customers and potential customers of the system that includes the outputs of requirements RS1.2, RS1.7 and RS1.8, and any unsupported uses defined in the Impact Assessment and in RS1.8. When the system is a platform service made available to external customers or partners, include this information in the required Transparency Note.',
                    tags:['Impact Assessment','Transparency Note.']
                },
            ]
        },
        {
            goal: 'Failures and remediations',
            PreGoal:'Goal RS2:',
            description: 'AI systems are designed to minimize the time to remediation of predictable or known failures.',
            appliesTo: 'All AI systems.',
            requirements: [
                {
                    id: 'RS2.1',
                    text: 'Define predictable failures, including false positive and false negative results for the system as a whole and how they would impact stakeholders for each intended use. Use the Impact Assessment template to document any adverse impacts of these failures on stakeholders.',
                    tags: ['Impact Assessment']
                },
                {
                    id: 'RS2.2',
                    text: 'For each case of a predictable failure likely to have an adverse impact on a stakeholder, document the failure management approach:',
                    subRequirements: [
                        "When possible, design and build the system to avoid this failure. Describe the design solution. Estimate the time range for resolving predictable failures for each designed solution or indicate that the failure will be prevented by design.",	
                        "When a failure cannot be prevented by design, build a fallback option that may be used when this failure occurs. Describe the fallback option and document the estimated time required to invoke and use the fallback option.",
                        "Provide training and documentation for stakeholders accountable for system oversight that supports their resolution of the failure. Describe the documentation and training.",
                    ],
                    tags: null
                },
                {
                    id: 'RS2.3',
                    text: 'Document your plan for managing previously unknown failures that come to light once the system is in use:',
                    subRequirements: [
                        "Describe the system’s rollback plan and document the time that may elapse until the entire system, across all endpoints can be rolled back.",	
                        "Describe support for turning features off and document the time that may elapse until the feature can be turned off across all endpoints.",
                        "Describe the process for updating and releasing updates to each model and document the time that may elapse until the system has been updated across all endpoints.",
                        "Describe how customers, partners, and end users will be notified of changes to the system, updated understandings of failures, and their best mitigations.",
                    ],
                    tags: null
                },
                {
                    id: 'RS2.4',
                    text: 'Provide training and documentation for system owners, developers, customer support and other stakeholders responsible for managing the system to support their remediation and mitigation of predictable failures identified in requirement RS2.1. Document the training and documentation provided.',
                    tags: null
                },
                
            ]
        },
        {
            goal: 'Ongoing monitoring, feedback, and evaluation',
            PreGoal:'Goal RS3:',
            description: 'AI systems are subject to ongoing monitoring, feedback, and evaluation so that we can identify and review new uses, identify and troubleshoot issues, manage and maintain the systems, and improve them over time.',
            appliesTo: 'All AI systems.',
            requirements: [
                {
                    id: 'RS3.1',
                    text: 'Establish and document a detailed inventory of the system health monitoring methods to be used, to include:',
                    subRequirements: [
                        "data and insights generated from data repositories, system analytics, and associated alerts,",
                        "processes by which customers can submit information about failures and concerns, and",
                        "processes by which the general public can submit feedback.",
                    ],
                    tags: null
                },
                {
                    id: 'RS3.2',
                    text: 'Define and document a standard operating procedure and system health monitoring action plan for each monitoring channel for the system, to include:',
                    subRequirements: [
                        "processes for reproducing system failures to support troubleshooting and prevention of future failures,",
                        "which events will be monitored,",
                        "how events will be prioritized for review,",
                        "the expected frequency of those reviews,",
                        "how events will be prioritized for response and timing to resolution,",
                        "how high priority issues related to supporting the Standard and its goals will be escalated to the responsible person(s), and",
                        "engaging customer service to ensure that they are aware of how to respond to issues for the system.",
                    ],
                    tags: null
                },
                {
                    id: 'RS3.3',
                    text: 'When new uses, critical operational factors, or changes in the supported range of an operational factor are identified, determine whether any new use or operational factor can be supported with the existing system, will be supported but require additional work, or will not be supported.',
                    subRequirements2: [
                        "When new uses or operational factors identified are to be supported, evaluate the updated system in accordance with requirement RS1.6, add the new intended use to the Impact Assessment, and publish updated communication in accordance with requirement RS1.9.",
                        "When these new uses or operational factor range changes cannot or will not be accommodated to ensure reliable and safe performance of the system update customer documentation described in RS1.9 to includethe new use as an unsupported use.",
                    ],
                    text2: 'When the system is a platform service made available to external customers or partners, include this information in the required Transparency Note.',
                    tags: ['Impact Assessment', 'Transparency Note']
                },
                {
                    id: 'RS3.4',
                    text: 'When a system is to be used for a Sensitive Use that imposes qualification or quality control requirements beyond the intended uses and/or operational factor ranges, conduct an evaluation specific to this use. If the required Responsible Release Criteria cannot be met, the responsible person (sI should review the results and decide how to proceed. Document any changes to the Responsible Release Criteria and document the results of evaluation.',
                    tags: null
                },
                {
                    id: 'RS3.5',
                    text: 'Conduct all evaluations tagged as Ongoing Evaluation Checkpoints in other Goals on an ongoing basis.',
                    tags: null
                },
                {
                    id: 'RS3.6',
                    text: 'If there are targets in Ongoing Evaluation Checkpoints that are no longer satisfied, consult with named reviewers, and in the case of Sensitive Uses, with the responsible person(s), to develop and implement a plan to close any gaps. Document the process, its results, and conclusions.',
                    tags: null
                },
                {
                    id: 'RS3.7',
                    text: 'If evidence comes to light that refutes the system is fit for purpose for an intended use at any point in the system’s use:',
                    subRequirements: [
                        "remove the intended use from customer-facing materials and make current customers aware of the issue, take action to close the identified gap, or discontinue the system,",
                        "revise documentation related to the intended use, and",
                        "publish the revised documentation to customers.",
                    ],
                    text2: 'When the system is a platform service made available to external customers or partners, include this information in the required Transparency Note.',
                    tags: ['Transparency Note.']
                },
                {
                    id: 'RS3.8',
                    text: 'Review and update documentation required by Goal T2 when any of the following events occur:',
                    subRequirements: [
                        "functionality changes,",
                        "new information about reliable and safe performance becomes known as defined by requirement RS3.3, or",
                        "new information about system accuracy and performance becomes available.",
                        "new uses are added,",
                    ],
                    text2: 'When the system is a platform service made available to external customers or partners, include this information in the required Transparency Note.',
                    tags: ['Transparency Note.']
                },
                {
                    id: 'RS3.9',
                    text: 'Escalate unresolved issues related to supporting the Standard and its requirements to the responsible person(s).',
                    tags: null
                },
            ]
        },
    ];
 

  // Modal component
  const DashModal = ({ isOpen, onClose, selectedGroup }) => {
    if (!isOpen || !selectedGroup) return null;
  
    // Fetch the specific goal data based on `selectedGroup`
    const goalData = goals.find(goal => goal.goal === selectedGroup);
  
    if (!goalData) return null;
  
    return (
      <div className="dashModal">
        <div className="dashModalContent">
          <div className="dashModalBox">
            {/* Title Section */}
            <h2 className="goal-title">
              <span className="goal-prefix">{goalData.PreGoal}</span> <span className="reli-goal-name">{goalData.goal}</span>
            </h2>
            <p className="applies-to">{goalData.description}</p>
            <p className="applies-to"><i>Applies to:</i> {goalData.appliesTo}</p>    
            {/* Requirements Table */}
            <div className="assessmentContainerBox">
              <table className="assessment-table">
                <thead>
                  <tr>
                    <th className="reli-requirements-header">Requirements</th>
                  </tr>
                </thead>
                <tbody>
                  {goalData.requirements.map((requirement, index) => (
                    <tr key={index} className="requirement-row">
                      <td className="requirement-text">
                        <strong>{requirement.id}</strong> {requirement.text}
                        <br/>{requirement.text3}
                        {requirement.subRequirements && (
                            <ul className="sub-requirements-list">
                            {requirement.subRequirements.map((subRequirement, subIndex) => (
                                <li key={subIndex} className="sub-requirement-item">
                                {subRequirement}
                                </li>
                            ))}
                            </ul>
                        )}
                        {requirement.subRequirements2 && (
                            <ul className="sub-requirements2-list">
                            {requirement.subRequirements2.map((subRequirement, subIndex) => (
                                <li key={subIndex} className="sub-requirement-item">
                                {subRequirement}
                                </li>
                            ))}
                            </ul>
                        )}
                        {requirement.text2}
                        {requirement.tags && requirement.tags.length > 0 && (
                            <p className="tags">
                            <strong>Tags:</strong> {requirement.tags.join(', ')}
                            </p>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
  
            {/* Close Button */}
            <button className="reli-closeButton" onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
    );
  };
  


  // Handle modal opening
  const openModal = (group) => {
    console.log(`Opening modal for: ${group}`);
    setSelectedGroup(group);
    setIsDashModalOpen(true);
  };

  const closeModal = () => {
    setIsDashModalOpen(false);
    setSelectedGroup(null);
  };

  


  return (
    <div style={{backgroundColor: 'rgb(240, 242, 245)', height: '100vh'}}>
      <div className='dashcontent'>
        <div>
          <h2>Reliability & Safety Goals</h2>
        </div>
        <div className="reli-container">
          <div className="stats-box" onClick={() => openModal('Reliability and safety guidance')}>
            <div className="icon-box black">
              <PiStrategyBold />
            </div>
            <div className="reli-content-box">
              <br></br>
              <br></br>
              <h4>Goal RS1:</h4>
              <h3>Reliability and safety guidance</h3>
              <hr className="hrLine" />
              <p className="change-text">Just Updated</p>
            </div>
          </div>
        
          <div className="stats-box" onClick={() => openModal('Failures and remediations')}>
            <div className="icon-box blue">
              <FaUniversalAccess />
            </div>
            <div className="reli-content-box">
              <br></br>
              <br></br>
              <h4>Goal RS2:</h4>
              <h3>Failures and remediations</h3>
              <hr className="hrLine" />
              <p className="change-text">Just Updated</p>
            </div>
          </div>

          {/* Identifiability and Linkability */}
          <div className="stats-box" onClick={() => openModal('Ongoing monitoring, feedback, and evaluation')}>
            <div className="icon-box green">
              <PiIdentificationCardFill />
            </div>
            <div className="reli-content-box">
              <br></br>
              <br></br>
              <h4>Goal RS3:</h4>
              <h3>Ongoing monitoring, feedback, and evaluation</h3>
              <hr className="hrLine" />
              <p className="change-text">Just Updated</p>
            </div>
          </div>
        </div>
        {/* Modal for displaying the questions with recommendations */}
        <DashModal isOpen={isDashModalOpen} onClose={closeModal} selectedGroup={selectedGroup} />
      </div>
    </div>
  );
};

    

export default Reliability;